import axios from 'axios';
import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  AccessibilityWrapper,
  LoadingSpinner,
  notify,
} from 'legacy-packages/ft-cb';
import PopOver from 'chameleon/ui-stack/ui/base/popover';
import Button from 'chameleon/ui-stack/ui/base/button';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import AssociatedResources from 'legacy-src/components/assignment/Assignment/components/AssociatedResources';
import ShareResourcePDFAction from 'legacy/src/utility/AssessmentActions/actions/ShareResourcePDFAction';
// Actions
import {
  AssignPseudoAction,
  DuplicatePseudoAction,
  EditPseudoAction,
  SharePseudoAction,
} from 'chameleon/ui-stack/ui/assessments/actions/phanthom-actions';
import AssignAction from 'legacy/src/utility/AssessmentActions/actions/AssignAction';
import getCopyableDetails from 'legacy/src/components/assignment/handlers/getCopyableDetails';
import CopyLinkAction from 'legacy/src/utility/AssessmentActions/actions/CopyLinkAction';
import EditAction from 'legacy/src/utility/AssessmentActions/actions/EditAction';
import PreviewAction from 'legacy/src/utility/AssessmentActions/actions/PreviewAction';
import UnlockAction from 'legacy/src/utility/AssessmentActions/actions/UnlockAction';
import MarkCompleteAction from 'legacy/src/utility/AssessmentActions/actions/MarkCompleteAction';
import VideoMarkCompleteAction from 'legacy/src/utility/AssessmentActions/actions/VideoMarkCompleteAction';
import UpdateSettingsAction from 'legacy/src/utility/AssessmentActions/actions/UpdateSettingsAction';
import ViewResultsAction from 'legacy/src/utility/AssessmentActions/actions/ViewResultsAction';
import ViewQuizSummaryAction from 'legacy/src/utility/AssessmentActions/actions/ViewQuizSummaryAction';
import DuplicateQuizAction from 'legacy/src/utility/AssessmentActions/actions/DuplicateQuizAction';
import DeleteAction from 'legacy/src/utility/AssessmentActions/actions/DeleteAction';
import ShowHideResultsForStudentsAction from 'legacy/src/utility/AssessmentActions/actions/ShowHideResultsForStudentsAction';
import AnswerSheetActions from 'legacy/src/utility/AssessmentActions/actions/AnswerSheetActions';
import GoToAssignmentsOverviewAction from 'legacy/src/utility/AssessmentActions/actions/GoToAssignmentsOverviewAction';
import MarkCompleteWithModalAction from 'legacy/src/utility/AssessmentActions/actions/MarkCompleteWithModalAction';
import ReOpenAction from 'legacy/src/utility/AssessmentActions/actions/ReOpenAction';
import SubmitUnsubmit from 'legacy/src/components/assignment/Assignment/components/Actions/SubmitUnsubmit';
import { downloadAllAnswerSheets as downloadAllAnswerSheetsAction } from 'legacy/src/actions/paperscorer';
import deleteAssessment from 'legacy/src/components/questionBank/QuizBuilder/utils/deleteAssessment';
import EditOptions from 'legacy/src/utility/AssessmentActions/actions/EditOptions';
import { ASSIGNMENT_STATUSES } from 'chameleon-src/constants/assessmentStatus';
import {
  GenerateAnswerSheetModal,
  UploadAnswerSheetsToast,
} from 'legacy/src/components/paperscorer';
import {
  PPC,
  PE,
  TEACHER_AUTHORED,
  LEARNING_CHECKPOINTS,
  PERFORMANCE_TASKS,
} from 'chameleon-src/components/assignments/constants';
import { resourceTypes } from 'chameleon/legacy/src/components/TeacherOrganize/utils/constants';

import { deleteApVideoAssignment } from 'legacy-src/queries';

// Utilities
import { graphqlWrapper } from 'legacy/src/utility/graphqlWrapper';
import log from 'chameleon/ui-stack/utilities/log';

import buildSectionStudents from 'chameleon/ui-stack/utilities/utils/buildSectionStudents';
import { toast } from 'chameleon/ui-stack/ui/toast';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import useSppTelemetrySend from 'chameleon/ui-stack/utilities/use-spp-telemetry-send';
import { FlyoutSecondMenu } from 'chameleon/ui-stack/ui/assessments/actions/FlyoutSecondMenu';
import {
  popoverClassName,
  ulClassName,
} from 'chameleon/ui-stack/ui/basic/simple-actions';
import { buildUrl } from 'legacy-src/utility/buildUrl';
import buildSubgroupStudents from 'chameleon/ui-stack/utilities/utils/buildSubgroupStudents';
import LabelListMenu from 'legacy-src/components/TeacherOrganize/components/LabelListMenu';
import { useTeacherOrganizeContext } from 'legacy-src/components/TeacherOrganize/hooks/useTeacherOrganize';
import ShareWrapper from 'chameleon/packages/units/components/ShareWrapper';
import { get, isNil } from 'lodash';
import React, { Fragment, useRef, useState, useEffect, useMemo } from 'react';
import { AccessibleMenuWithArrows } from './AccessibleMenuWithArrows';
import {
  deleteAssignmentByTeacher,
  sppMarkCompleteByTeacher,
  sppDeleteAssessment,
} from './telemetry';

import {
  COPY_LINK,
  MARK_COMPLETE,
  VIEW_RESULTS,
  getAssignmentActions,
  getResourceActions,
  UPDATE_SETTINGS,
  MANAGE_ASSIGNMENT,
  DELETE_ASSIGNMENT,
  PREVIEW,
  VIEW_SUMMARY,
  ASSIGN,
  REASSIGN,
  DUPLICATE_QUIZ,
  EDIT_QUIZ,
  SHARE_QUIZ,
  UPDATE_LABELS,
  DELETE_QUIZ,
  SHOW_HIDE_RESULTS_FOR_STUDENTS,
  ANSWER_SHEETS_ACTIONS,
  RELATED_PDFS_ACTIONS,
} from './constants';

import SingleAction from './single-action';

const Actions = (props) => {
  const {
    basePathname = { pathname: '', query: {} },
    assignment,
    assessment,
    me,
    subjectInfo,
    fetchAssessmentData = () => {},
    fetchAssignmentData = () => {},
    router,
    params,
    hasStudents = false,
    subjectInitId,
    isSPP = false,
    isPDF = false,
    overrides,
    action_overrides,
    isButton,
    isPilot = false,
    paperScorerAnswerSheets,
    showPaperscorerLinks,
    section = '',
    hasSubmitUnsubmit = false,
    teacherSubmitUnsubmitFF = false,
    showLabelActions = false,
    hasOneInProgressSubmission = null,
    showVideoMarkCompleteFlag = false,
    userIdsWithProgress = [],
    downloadAllAnswerSheets,
    loadingAllAnswerSheets,
    userData,
    subjectName,
    isVideo = false,
    assessmentPreviewURL = '',
    type = '',
    location,
    userClasses,
    chosenEducationPeriodCode,
    studentsBySection,
    isAllResourcesPage = false,
    apEditQuizInPreview,
    sendTelemetryEvent = () => {},
    closeQuizReturnPath,
    startsAt,
    dueAt,
    resultsAssignmentActionsEnabled,
    submissions,
    shareAssessmentInviteItemId,
    enableSharedAssessments,
    isMyAssignmentsPage = false,
    isSharer,
    isSharedAssessment = false,
    isSharedByMe = false,
    client,
    setStartDueTimes = () => {},
    activeEducationPeriodFromFiltersControl = false,
    videoResourcesByResourceId,
    disabled = false,
    onResourceLabelUpdate,
    isAssignedResourcesPage,
    useNewGroupedActionsFF,
    progress,
    isMCQPPC,
  } = props;

  const {
    routes,
    location: { pathname, query },
  } = router;
  const [openEditOptionsModal, setOpenEditOptionsModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isPreviousEducationPeriod, setIsPreviousEducationPeriod] =
    useState(false);
  const { isAdmin, isCoordinator } = userData || {};
  const [uploadLoading, setUploadLoading] = useState(false);
  const isAdminOrCoordinator = isAdmin || isCoordinator;
  const userCurrentClasses = userClasses.filter(
    (c) =>
      c.educationPeriod.toString() === chosenEducationPeriodCode.toString(),
  );
  const isResultsOverviewPage = pathname.includes('/assessments/results/');
  const isAssignmentOverviewPage = pathname.includes('/assignments/progress/');
  const { sections = [] } = me;
  const {
    id: assessment_id,
    title: assessmentTitle,
    is_assigned: isAssigned = false,
    is_in_progress: isInProgress,
    is_ppc: isPPCAssessment,
    is_in_co_taught_class: isCoTaught,
    actions: assessmentActions = [],
    provider_video_id: videoId = '',
    unit_id: videoUnit = '',
    resource_id: videoResourceId = '',
    learnosity_reference: learnosityReference,
    assignments: assessmentAssignments = [],
  } = assessment || {};
  const {
    actions: assignmentActions = [],
    id: assignment_id,
    title,
    print_toggle: printToggle,
    sub_group_students,
    item: { is_practice_exam: itemIsPracticeExam } = {},
  } = assignment || {};
  let sectionStudents = !isNil(assignment)
    ? buildSectionStudents(
        get(
          studentsBySection,
          [Number.parseInt(assignment.section_id, 10)],
          [],
        ),
        sub_group_students,
      )
    : null;
  const hasActiveAnswersheets = !isNil(assignment)
    ? assignment.has_active_answersheets
    : false;

  const isAssignment =
    assignment_id && Number(assignment_id) !== Number(assessment_id);

  const actions = isAssignment ? assignmentActions : assessmentActions;
  const subGroupStudents = buildSubgroupStudents(
    assignment.sub_group_students,
    studentsBySection,
  );
  const displayNameOfClassOrStudent =
    subGroupStudents.length === 1
      ? `${get(subGroupStudents[0], 'first_name')} ${get(
          subGroupStudents[0],
          'last_name',
        )}`
      : assignment.section_name;

  const {
    queryParams,
    pushParamsToHistory,
    isAssignmentProgressPage,
    isAssignmentsPage,
    isQuestionBankPage,
    isSharedAssessmentPage,
  } = useNavigation({
    router,
  });

  const statuses = queryParams.status?.split(',') || [];

  const displayAssignmentActions =
    statuses.every((status) => ASSIGNMENT_STATUSES.includes(status)) &&
    !isQuestionBankPage &&
    !isSharedAssessmentPage; // Hide assignment actions on the question bank page and shared assessment page. Display only resource actions

  const sppTelemetrySend = useSppTelemetrySend({ subject: subjectInfo });
  const {
    actions: labelActions,
    state: { isBulkMode },
  } = useTeacherOrganizeContext({});

  const label = isButton ? (
    <Button
      tabIndex={0}
      disabled={isBulkMode || disabled}
      isSecondary={resultsAssignmentActionsEnabled}
      isPrimary={!resultsAssignmentActionsEnabled}
    >
      Actions{' '}
      {resultsAssignmentActionsEnabled && <Icon name="keyboard_arrow_down" />}
    </Button>
  ) : (
    <ButtonWithIcon
      disabled={isBulkMode || disabled}
      isIcon
      isNaked
      aria-label="Actions"
      icon="more-actions"
    />
  );
  const assessmentAssignmentsActions = assessmentAssignments.length
    ? assessmentAssignments.find(
        (assignment) => assignment.id === assignment_id,
      )
    : [];

  const assignmentsActions = get(assessmentAssignmentsActions, 'actions', []);
  const currentEducationPeriod = Number(
    userData.educationPeriod.currentEducationPeriod.id,
  );

  const showPreview = actions.includes('preview');
  const showEdit = actions.includes('edit');
  const showMarkComplete =
    !isAssignmentProgressPage && actions.includes('mark_complete');
  const showVideoMarkComplete = actions.includes('video_mark_complete');
  const showUnlock = actions.includes('unlock');
  const showAssign = actions.includes('assign');
  const showReassign =
    (actions.includes('reassign') || assignmentsActions.includes('reassign')) &&
    !isPreviousEducationPeriod;
  const showUpdateSettings =
    actions.includes('update_settings') && !isPreviousEducationPeriod;
  const showViewResults =
    actions.includes(VIEW_RESULTS) ||
    progress?.scored > 0 ||
    progress?.complete > 0;
  const showCopyLink = actions.includes('share_link');
  const showDuplicateQuiz = actions.includes('copy');
  const showDeleteQuiz = actions.includes('delete') && !isSharedByMe; // Hide the delete quiz icon for shared by me items
  const showAvailableResultsForStudentsAction =
    actions.includes('show_available_results_for_students') &&
    !isSPP &&
    !isPreviousEducationPeriod;
  const showGoToAssignmentsOverviewAction =
    actions.includes('show_go_to_assignment_overview') &&
    !isPreviousEducationPeriod;
  const showMarkCompleteWithModal =
    isAssignmentProgressPage && actions.includes('mark_complete');
  const showReOpen = actions.includes('reopen') && !isPreviousEducationPeriod;
  const showDownloadAnswerSheets = actions.includes('download_answer_sheets');
  const showGenerateNewAnswerSheets = actions.includes(
    'generate_new_answer_sheets',
  );
  const showUploadAnswerSheets = actions.includes('upload_answer_sheets');
  const showShareQuiz = enableSharedAssessments && actions.includes('share');
  const hasClasses =
    me &&
    sections.some((section) => section.masterSubjectId === subjectInfo.id);

  const isPPC = type === PPC || isPPCAssessment;
  const isPE = type === PE || itemIsPracticeExam;
  const isLC = type === LEARNING_CHECKPOINTS;
  const isPT = type === PERFORMANCE_TASKS;
  const isMyQuiz = type === TEACHER_AUTHORED || isCoTaught || type === '';
  const isClosed = assignment.status === 'closed';

  const onDelete = overrides && overrides.delete;
  const onComplete = overrides && overrides.mark_complete;
  const onUpdate = overrides && overrides.update_settings;
  const onUpdateClick = action_overrides && action_overrides.update_settings;

  const canRenderPaperscorerAnswerSheets =
    paperScorerAnswerSheets && hasStudents && printToggle;

  const currentId = isAssignment ? assignment_id : assessment_id;

  const onAssign = () => {
    // re-fetch assignment information after successful assigning
    // https://academicmerit.atlassian.net/browse/FY-23422
    fetchAssessmentData();
  };

  const popover = useRef(null);

  const closePopUp = () => (popover.current ? popover.current.close() : {});
  const numberOfUnsubmittedAssignments = submissions
    ? submissions.reduce(
        (totalAssignments, currAssignment) =>
          totalAssignments +
          +(!!currAssignment.assignment_id && !!!currAssignment.submitted),
        0,
      )
    : 0;

  const classId = assignment.section_id;

  const gotoEdit = () => {
    if (isAssignmentProgressPage || !apEditQuizInPreview) {
      pushParamsToHistory(
        { quizId: assessment_id, editMode: true, closeQuizReturnPath },
        `/${params.subject}/question_bank/create`,
      );
      return;
    }
    pushParamsToHistory({
      quizId: assessment_id,
      previewEditMode: true,
      closeQuizReturnPath,
    });
  };

  const onEditClick = () => {
    sendTelemetryEvent({ eventType: 'edit_action' });
    setOpenEditOptionsModal(true);
  };

  /*
    - We need to create this method unlike assignment progress page which comes with 'deleteAssignment'
    from <Assignment/> component
    - If we want, we can refactor this in a separate ticket because it would take a lot of dev effort to make it generic
  */
  const deleteAssignment = (callback) => {
    const status = 'deleted';
    const { id } = assignment;

    axios({
      method: 'put',
      url: `${FYM_BACKEND_URL}/assessments/api/assignments/${id}/`,
      data: {
        status,
        title: assignment.title,
        score_display: assignment.score_display,
        student_scoring: assignment.student_scoring,
        timer: assignment.timer,
      },
    })
      .then((response) => {
        const { data: responseData } = response;
        if (callback) {
          callback(responseData);
        } else {
          router.push(`/${params.subject}/assignments/progress/${id}`);
        }
      })
      .catch((error) => {
        log('error', error);
      });
  };

  const deleteVideoAssignment = async (callBack) => {
    const response = await client.mutate({
      mutation: deleteApVideoAssignment,
      variables: {
        id: +assignment.id,
      },
    });

    const { ok } = response.data.deleteApVideoAssignment;

    if (ok) {
      response.status = 'deleted';

      if (callBack) {
        callBack(response);
      }
    } else {
      log(
        'error',
        `Unable to delete ap daily video with id of ${assignment.id}`,
      );
    }
  };

  const onAssignmentDelete = () => {
    const callBack = (response) => {
      /**
       * we only need to fetch assignment data if we try and delete from
       * the assignments page. If we do it from the progress page, nagivating to the
       * assignments page will automatically fetch assignments
       */
      if (response) {
        const { status } = response;

        if (status === 'deleted') {
          if (isSPP) {
            sendSppDeletedEvent();
          } else {
            sendAssignmentDeleteEvent();
          }
          toast('Assignment deleted', { timeout: 5 });
          if (isButton) {
            // we're on the progress page, we need to go to assignments page
            router.push(basePathname);
          } else {
            // we're already on the assignments page, we need to refetch the assignments
            fetchAssessmentData();
          }
        }
      }
    };

    try {
      if (isVideo) {
        deleteVideoAssignment(callBack);
      } else if (onDelete) {
        onDelete(callBack);
      } else {
        deleteAssignment(callBack);
      }
    } catch (e) {
      log(e);
    }
  };

  const uploadRef = useRef(null);

  const uploadFiles = (event) => {
    const { files } = event.target;
    const formData = new FormData();

    Array.from(files).map((file) => formData.append('files', file));
    setUploadLoading(true);
    axios
      .post(
        `${FYM_BACKEND_PAPERSCORER_API_URL}/submit_answer_sheet`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then((response) => {
        const { successfull, failed } = response.data;

        if (failed.length === 0 && successfull !== null) {
          UploadAnswerSheetsToast();
        } else if (failed.length > 0) {
          toast.error(`${failed.length} answer sheet(s) uploads failed.`);
        } else {
          toast.error("Couldn't upload file(s), please contact support");
        }
      })
      .catch((error) => {
        log(error);
      })
      .finally(() => {
        setUploadLoading(false);
      });
  };
  const deleteQuiz = async () => {
    closePopUp();
    const response = await deleteAssessment(client, currentId, false);

    if (response) {
      const { deleted, message } = response;

      if (deleted) {
        toast('Assessment deleted', { timeout: 5 });
        fetchAssessmentData();
      } else {
        notify.error(message);
      }
    }
  };

  const stopPropagation =
    (fn) =>
    (e, ...args) => {
      e && e.stopPropagation();
      fn(...args);
    };

  const videoAssignProps = {
    isVideo,
    videoId,
    videoResource: { unit: { id: videoUnit, unitId: videoUnit } },
    videoResourceId,
    onVideoAssigned: () => fetchAssessmentData(),
    userClasses: userCurrentClasses,
    resources: [get(videoResourcesByResourceId, videoResourceId)],
  };

  const copyDetails = isVideo
    ? `${FYM_FRONTEND_URL}/d/${videoId}?sui=${params.subject},${videoUnit}`
    : getCopyableDetails(
        assignment,
        params.subject,
        false,
        studentsBySection,
        isSPP,
      );

  const sendSppMarkCompleteEvent = () => {
    sppTelemetrySend(
      sppMarkCompleteByTeacher({
        isComplete: isClosed,
        sppId: assessment_id && Number(assessment_id),
        sppTitle: assessmentTitle,
        assignmentId: assignment_id && Number(assignment_id),
      }),
    );
  };

  const learnosityItemReference = get(assignment, 'item')
    ? assignment.item.learnosity_item_reference
    : learnosityReference;

  const sendSppDeletedEvent = () => {
    sppTelemetrySend(
      sppDeleteAssessment({
        spp_learnosity_reference: learnosityItemReference,
        spp_title: assessmentTitle,
        spp_id: assessment_id && Number(assessment_id),
        assignmentId: assignment_id && Number(assignment_id),
      }),
    );
  };

  const sendAssignmentDeleteEvent = () => {
    sppTelemetrySend(
      deleteAssignmentByTeacher({
        title: assessmentTitle,
        assignmentId: assignment_id && Number(assignment_id),
        section: isMyAssignmentsPage ? 'My Assignments' : 'Assignment Overview',
      }),
    );
  };

  const handleManageShare = () => {
    closePopUp();
    router.push({
      pathname,
      query: {
        ...query,
        manageShare: true,
        itemId: assessment_id,
        itemTitle: assessmentTitle,
      },
    });
  };

  const updateLabels = async (selectedLabels) => {
    const labelIds = Object.keys(selectedLabels).filter(
      (key) => selectedLabels[key],
    );

    const associationData = isVideo
      ? { resourceId: assessment_id, labelIds }
      : { quizId: assessment_id, labelIds };

    const actionMethod = isVideo
      ? labelActions.createLabelResourceAssociations
      : labelActions.createLabelItemAssociations;
    const response = await actionMethod(associationData);

    if (response.success) {
      assessmentTitle &&
        toast(`Your labels have been updated for ${assessmentTitle}`);

      if (onResourceLabelUpdate) {
        onResourceLabelUpdate({
          resourceId: assessment_id,
          type: isVideo ? resourceTypes.video : resourceTypes.item,
          labelIds: labelIds.map((labelId) => Number.parseInt(labelId, 10)),
        });
      }
      fetchAssessmentData();
    }
  };

  useEffect(() => {
    setStartDueTimes({ startsAt, dueAt });
    setIsPreviousEducationPeriod(
      Number(chosenEducationPeriodCode) < currentEducationPeriod ||
        (activeEducationPeriodFromFiltersControl !== false &&
          (activeEducationPeriodFromFiltersControl < currentEducationPeriod ||
            activeEducationPeriodFromFiltersControl <
              Number(chosenEducationPeriodCode))),
    );
  }, [startsAt, dueAt, currentEducationPeriod]);

  const assignmentGroupActions = useMemo(
    () =>
      getAssignmentActions(
        isResultsOverviewPage,
        isAssignmentOverviewPage,
        isVideo,
        isSPP,
      ),
    [isResultsOverviewPage, isAssignmentOverviewPage, isVideo, isSPP],
  );

  const resourceGroupActions = useMemo(
    () =>
      getResourceActions(
        isPPC,
        isSPP,
        isPE,
        isVideo,
        isMyQuiz,
        isAllResourcesPage,
        isLC,
        isPT,
      ),
    [isPPC, isSPP, isPE, isVideo, isMyQuiz, isAllResourcesPage, isLC, isPT],
  );

  const MarkCompleteVideoAction = () => (
    <React.Fragment>
      {true && (
        <VideoMarkCompleteAction
          disabled={!(showVideoMarkComplete && showVideoMarkCompleteFlag)}
          assignmentId={assignment_id}
          onUpdate={
            (overrides && overrides.video_mark_complete) ||
            (() => {
              fetchAssessmentData();
            })
          }
        />
      )}
    </React.Fragment>
  );

  const renderMarkCompleteAction = () =>
    isVideo ? (
      <MarkCompleteVideoAction />
    ) : showMarkCompleteWithModal ? (
      <MarkCompleteWithModalAction
        onComplete={() => {
          onComplete();
          isSPP && sendSppMarkCompleteEvent();
          closePopUp();
        }}
      />
    ) : (
      <MarkCompleteAction
        disabled={!showMarkComplete}
        assignmentId={assignment_id}
        onUpdate={
          (overrides && overrides.mark_complete) ||
          (() => {
            isSPP && sendSppMarkCompleteEvent();
            fetchAssessmentData();
            closePopUp();
          })
        }
      />
    );

  const answerSheetActionsProps = {
    showGenerateNewAnswerSheets,
    canRenderPaperscorerAnswerSheets,
    showPaperscorerLinks,
    closePopUp,
    setModalOpen,
    hasActiveAnswersheets,
    downloadAllAnswerSheets,
    assignment_id,
    title,
    section,
    subjectName,
    loadingAllAnswerSheets,
    showDownloadAnswerSheets,
    uploadRef,
    uploadFiles,
    uploadLoading,
  };

  const isMCQPPCProp =
    isMCQPPC !== undefined ? isMCQPPC : !assessment.has_frq_questions && isPPC;

  const getTransformedResources = (resources) =>
    (resources || []).map(({ resource_type, resource_url, order }) => ({
      resourceType: resource_type,
      resourceUrl: resource_url,
      order,
    }));

  const associatedResourcesProps = {
    client,
    assignmentId: assignment_id,
    masterSubjectId: subjectInfo.id,
    isMCQPPC: isMCQPPCProp,
    resources: getTransformedResources(
      assignment.assignment?.associated_resources,
    ),
    assessmentId: assessment_id,
    educationPeriod: chosenEducationPeriodCode,
  };

  const renderUpdateLabelAction = () =>
    isAssignmentsPage && showLabelActions && !isPDF ? (
      <FlyoutSecondMenu
        isNarrow
        className="update-labels"
        trigger={(buttonProps, isOpen, reference) => (
          <SingleAction
            isNaked
            aria-label="Update Labels"
            iconName="update_label"
            ref={reference}
            {...buttonProps}
          >
            <span className="text-16 item-text">Update Labels</span>
          </SingleAction>
        )}
      >
        <LabelListMenu
          onClose={updateLabels}
          assignedLabels={assessment.labels}
          isAdminOrCoordinator={isAdminOrCoordinator}
        />
      </FlyoutSecondMenu>
    ) : (
      <SingleAction
        disabled
        isNaked
        aria-label="Update Labels"
        iconName="update_label"
      >
        <span className="text-16 item-text">Update Labels</span>
      </SingleAction>
    );

  if (
    useNewGroupedActionsFF &&
    (displayAssignmentActions ||
      isAllResourcesPage ||
      isResultsOverviewPage ||
      isAssignmentOverviewPage) &&
    !isPDF
  ) {
    return (
      <Fragment>
        <PopOver
          disabled={isBulkMode || disabled}
          tabIndex={-1}
          ref={popover}
          contentClassName={popoverClassName}
          trigger={label}
        >
          <AccessibleMenuWithArrows ulClassName={ulClassName}>
            <div role="menu">
              {/* Here the beginning of the list of actions */}
              {/* Assignment Grouping: This should be only visible if we're in Assigned Resources tab, not all resources tab */}
              {(displayAssignmentActions ||
                isResultsOverviewPage ||
                isAssignmentOverviewPage) && (
                <Fragment>
                  <div className="flex justify-between items-center p-4">
                    <div>
                      <span
                        className="text-gray-600 font-medium mr-6 text-nowrap"
                        style={{ fontSize: '1.1rem' }}
                      >
                        THIS ASSIGNMENT
                      </span>
                    </div>
                    <div className="w-full border-top border-gray-500" />
                  </div>
                  <ul role="group" className="p-0 m-0">
                    {assignmentGroupActions.includes(UPDATE_SETTINGS) && (
                      <UpdateSettingsAction
                        assessment={assessment}
                        assignment={assignment}
                        subjectInitId={{
                          ...subjectInfo,
                          initId: Number(subjectInitId),
                        }}
                        onUpdate={onUpdate || fetchAssessmentData}
                        onActionClick={onUpdateClick}
                        onClose={closePopUp}
                        isPilot={isPilot}
                        isVideo={isVideo}
                        isSPP={isSPP}
                        videoUnit={videoUnit}
                        videoId={videoId}
                        startsAt={startsAt}
                        dueAt={dueAt}
                        isPPC={type === 'ppc'}
                        disabled={!showUpdateSettings}
                      />
                    )}
                    {assignmentGroupActions.includes(VIEW_RESULTS) && (
                      <div className="text-left">
                        <ViewResultsAction
                          assignmentId={assignment_id}
                          basePathname={basePathname}
                          subjectInfo={subjectInfo}
                          onClick={closePopUp}
                          disabled={!showViewResults}
                        />
                      </div>
                    )}
                    {assignmentGroupActions.includes(MARK_COMPLETE) &&
                      renderMarkCompleteAction()}
                    {showReOpen && (
                      <ReOpenAction
                        assignmentId={assignment_id}
                        onReOpen={overrides?.re_open}
                        afterReopen={
                          !overrides?.re_open
                            ? () => {
                                isSPP && sendSppMarkCompleteEvent();
                                fetchAssessmentData();
                                closePopUp();
                              }
                            : null
                        }
                      />
                    )}
                    {hasSubmitUnsubmit &&
                      teacherSubmitUnsubmitFF &&
                      hasOneInProgressSubmission && (
                        <SubmitUnsubmit
                          assignmentId={assignment_id}
                          labelText="Submit All Unsubmitted"
                          dialogTitle="Confirm Submit All"
                          dialogText="Are you sure you want to submit all students’ in-progress assignments?"
                          userIds={userIdsWithProgress}
                          onUpdate={() => {
                            fetchAssignmentData();
                            closePopUp();
                          }}
                          numberOfUnsubmittedAssignments={
                            numberOfUnsubmittedAssignments
                          }
                          assessmentId={assessment_id}
                          classId={classId}
                        />
                      )}
                    {assignmentGroupActions.includes(
                      SHOW_HIDE_RESULTS_FOR_STUDENTS,
                    ) && (
                      <ShowHideResultsForStudentsAction
                        assignment={assignment}
                        fetchAssessmentData={fetchAssessmentData}
                        disabled={!showAvailableResultsForStudentsAction}
                      />
                    )}
                    {assignmentGroupActions.includes(COPY_LINK) && (
                      <CopyLinkAction
                        detailsToBeCopied={copyDetails}
                        onClick={stopPropagation(closePopUp)}
                        disabled={!showCopyLink}
                      />
                    )}
                    {assignmentGroupActions.includes(MANAGE_ASSIGNMENT) && (
                      <GoToAssignmentsOverviewAction assignment={assignment} />
                    )}
                    {ANSWER_SHEETS_ACTIONS.every((action) =>
                      assignmentGroupActions.includes(action),
                    ) && <AnswerSheetActions {...answerSheetActionsProps} />}
                    {assignmentGroupActions.includes(DELETE_ASSIGNMENT) && (
                      <DeleteAction
                        disabled={!showDeleteQuiz}
                        onDelete={onAssignmentDelete}
                        isUnassignedAssessment={!isAssigned}
                        quizTitle={title || assessmentTitle}
                        quizId={assessment_id}
                        onAssessmentDelete={deleteQuiz}
                        isAllResourcesPage={isAllResourcesPage}
                        isSharedAssessment={isSharedAssessment}
                        sendTelemetryEvent={() => {
                          sendTelemetryEvent &&
                            sendTelemetryEvent({ eventType: 'delete_action' });
                        }}
                        totalStudents={subGroupStudents.length}
                        displayNameOfClassOrStudent={
                          displayNameOfClassOrStudent
                        }
                        isVideo={isVideo}
                        client={client}
                      />
                    )}
                  </ul>
                  {/* End of Assignment Grouping */}
                  {/* Here begins the resource grouping actions */}
                  <div className="flex justify-between items-center p-4">
                    <div>
                      <span
                        className="text-gray-600 font-medium mr-6"
                        style={{ fontSize: '1.1rem' }}
                      >
                        RESOURCE
                      </span>
                    </div>
                    <div className="w-full border-top border-gray-500" />
                  </div>
                </Fragment>
              )}
              {/* End of the list of actions for assignment */}
              <ul role="group" className="p-0 m-0">
                {resourceGroupActions?.includes(ASSIGN) &&
                  (!isCoTaught ? (
                    <AssignAction
                      subjectInfo={subjectInfo}
                      assessment={assessment}
                      assignment={assignment || {}}
                      onAssign={onAssign}
                      onClose={stopPropagation(closePopUp)}
                      isVideo={isVideo}
                      sendTelemetryEvent={() => {
                        sendTelemetryEvent &&
                          sendTelemetryEvent({ eventType: 'assign_action' });
                      }}
                      disabled={
                        !(showAssign && (hasClasses || isAdminOrCoordinator))
                      }
                      {...videoAssignProps}
                    />
                  ) : (
                    <AssignPseudoAction />
                  ))}
                {resourceGroupActions?.includes(REASSIGN) &&
                  (!isCoTaught ? (
                    <AssignAction
                      isReassign
                      forcePopupClose
                      subjectInfo={subjectInfo}
                      assessment={assessment}
                      assignment={assignment}
                      onAssign={onAssign}
                      onClose={closePopUp}
                      {...videoAssignProps}
                      disabled={!(showReassign && !isCoTaught)}
                    />
                  ) : (
                    <AssignPseudoAction showReassign />
                  ))}
                {resourceGroupActions?.includes(EDIT_QUIZ) &&
                  (!isCoTaught ? (
                    <EditAction
                      title={(showIcons) =>
                        showIcons ? 'Edit Quiz' : 'Edit Assessment'
                      }
                      arialLabel={(showIcons) =>
                        showIcons ? 'Edit Quiz' : 'Edit Assessment'
                      }
                      onClick={stopPropagation(onEditClick)}
                      label={<span className="item-text">Edit Quiz</span>}
                      disabled={!(showEdit && !isCoTaught)}
                    />
                  ) : (
                    <EditPseudoAction />
                  ))}
                {resourceGroupActions?.includes(PREVIEW) && (
                  <PreviewAction
                    assessmentId={assessment_id}
                    location={location}
                    assessmentPreviewURL={assessmentPreviewURL}
                    videoProviderId={videoId}
                    previewOpened={() => {
                      closePopUp();
                      sendTelemetryEvent &&
                        sendTelemetryEvent({ eventType: 'preview_action' });
                    }}
                    subjectInfo={subjectInfo}
                    isVideo={isVideo}
                    isSPP={isSPP}
                    disabled={!showPreview}
                  />
                )}
                {resourceGroupActions?.includes(VIEW_SUMMARY) && (
                  <ViewQuizSummaryAction
                    role="link"
                    quizSummaryId={assessment_id}
                    closePopUp={closePopUp}
                    disabled={
                      !(!isSPP && enableSharedAssessments && !isVideo && !isPDF)
                    }
                  />
                )}
                {RELATED_PDFS_ACTIONS.some((action) =>
                  resourceGroupActions?.includes(action),
                ) && (
                  <AssociatedResources
                    displayActionMenu
                    resourceGroupActions={resourceGroupActions}
                    {...associatedResourcesProps}
                  />
                )}
                {resourceGroupActions?.includes(UPDATE_LABELS) &&
                  renderUpdateLabelAction()}
                {resourceGroupActions?.includes(SHARE_QUIZ) &&
                  (!isCoTaught ? (
                    <SingleAction
                      disabled={!(showShareQuiz && !isPDF && !isCoTaught)}
                      isNaked
                      onClick={() => {
                        const newQuery = {
                          ...query,
                          shareAssessmentInviteItemId:
                            shareAssessmentInviteItemId || assessment.id,
                          assessmentTitle,
                        };
                        const newPathname = buildUrl(
                          routes,
                          null,
                          params,
                          newQuery,
                        );
                        router.push(newPathname);
                      }}
                      aria-label="Share Quiz"
                      iconName="share_invite"
                    >
                      <span className="item-text">Share Quiz</span>
                    </SingleAction>
                  ) : (
                    <SharePseudoAction />
                  ))}
                {resourceGroupActions?.includes(DUPLICATE_QUIZ) &&
                  (!isCoTaught ? (
                    <DuplicateQuizAction
                      assessmentId={assessment_id}
                      onClose={closePopUp}
                      disabled={!(showDuplicateQuiz && !isCoTaught)}
                    />
                  ) : (
                    <DuplicatePseudoAction />
                  ))}
                {resourceGroupActions?.includes(DELETE_QUIZ) && (
                  <DeleteAction
                    displayQuizLabel
                    disabled={
                      isAssignedResourcesPage ||
                      isAssignmentOverviewPage ||
                      !showDeleteQuiz
                    }
                    onDelete={onAssignmentDelete}
                    isUnassignedAssessment={!isAssigned}
                    quizTitle={title || assessmentTitle}
                    quizId={assessment_id}
                    onAssessmentDelete={deleteQuiz}
                    isAllResourcesPage={isAllResourcesPage}
                    isSharedAssessment={isSharedAssessment}
                    sendTelemetryEvent={() => {
                      sendTelemetryEvent &&
                        sendTelemetryEvent({ eventType: 'delete_action' });
                    }}
                    totalStudents={subGroupStudents.length}
                    displayNameOfClassOrStudent={displayNameOfClassOrStudent}
                    isVideo={isVideo}
                    client={client}
                  />
                )}
              </ul>
              {/* End Of Actions */}
              {openEditOptionsModal && (
                <EditOptions
                  isAssigned={isAssigned}
                  isInProgress={isInProgress}
                  onSubmit={gotoEdit}
                  masterSubjectId={subjectInfo.id}
                  assessmentId={assessment_id}
                  onClose={() => {
                    closePopUp();
                    setOpenEditOptionsModal(false);
                  }}
                />
              )}
            </div>
          </AccessibleMenuWithArrows>
        </PopOver>
        {modalOpen && (
          <GenerateAnswerSheetModal
            isQB={!isPPC}
            setModalOpen={setModalOpen}
            params={params}
            sectionStudents={sectionStudents}
            assignmentId={assignment_id}
            assignmentTitle={title}
            sectionName={section}
            closePopUp={closePopUp}
            userData={userData}
            assignment={assignment}
            skipQuestionTypeQuery={false}
          />
        )}
      </Fragment>
    );
  }

  if (isPDF) {
    return (
      <PopOver
        disabled={isBulkMode || disabled}
        tabIndex={-1}
        ref={popover}
        contentClassName={popoverClassName}
        trigger={label}
      >
        <AccessibleMenuWithArrows ulClassName={ulClassName}>
          <ShareResourcePDFAction
            assessment={assessment}
            chosenEducationPeriodCode={chosenEducationPeriodCode}
            stopPropagation={stopPropagation}
            closePopUp={closePopUp}
          />
        </AccessibleMenuWithArrows>
      </PopOver>
    );
  }

  // I think this part of the code is deprecated at this point
  // I think In all plaeces where actions component is used,
  // the return value is following the first if statement
  return (
    <Fragment>
      <PopOver
        disabled={isBulkMode || disabled}
        tabIndex={-1}
        ref={popover}
        contentClassName={popoverClassName}
        trigger={label}
      >
        <AccessibleMenuWithArrows ulClassName={ulClassName}>
          <Fragment>
            {showGoToAssignmentsOverviewAction && (
              <GoToAssignmentsOverviewAction assignment={assignment} />
            )}
            {showAssign &&
              (hasClasses || isAdminOrCoordinator) &&
              !isCoTaught && (
                <AssignAction
                  subjectInfo={subjectInfo}
                  assessment={assessment}
                  assignment={assignment || {}}
                  onAssign={onAssign}
                  onClose={stopPropagation(closePopUp)}
                  isVideo={isVideo}
                  sendTelemetryEvent={() => {
                    sendTelemetryEvent &&
                      sendTelemetryEvent({ eventType: 'assign_action' });
                  }}
                  {...videoAssignProps}
                />
              )}
            {isCoTaught && <AssignPseudoAction showReassign={showReassign} />}
            {showCopyLink && (
              <CopyLinkAction
                detailsToBeCopied={copyDetails}
                onClick={stopPropagation(closePopUp)}
              />
            )}
            {showDeleteQuiz && (
              <DeleteAction
                onDelete={onAssignmentDelete}
                isUnassignedAssessment={!isAssigned}
                quizTitle={title || assessmentTitle}
                quizId={assessment_id}
                onAssessmentDelete={deleteQuiz}
                isAllResourcesPage={isAllResourcesPage}
                isSharedAssessment={isSharedAssessment}
                sendTelemetryEvent={() => {
                  sendTelemetryEvent &&
                    sendTelemetryEvent({ eventType: 'delete_action' });
                }}
                totalStudents={subGroupStudents.length}
                displayNameOfClassOrStudent={displayNameOfClassOrStudent}
                isVideo={isVideo}
                client={client}
              />
            )}
            {isPDF && (
              <ShareWrapper
                text="Share resource"
                educationPeriod={chosenEducationPeriodCode}
                unitNumber={assessment.unit_id}
                id={assessment.id}
                onClose={stopPropagation(closePopUp)}
              />
            )}
            {showDownloadAnswerSheets &&
              hasActiveAnswersheets &&
              showPaperscorerLinks && (
                <AccessibilityWrapper>
                  <SingleAction
                    role="button"
                    tabIndex="0"
                    onClick={() =>
                      downloadAllAnswerSheets({
                        assignmentId: assignment_id,
                        assignmentName: title,
                        sectionName: section,
                        subjectName,
                      })
                    }
                    className="text-left"
                    iconName="download_sheet"
                    title="Download Answer Sheets"
                    ariaLabel="Download Answer Sheets"
                  >
                    <span className="item-text">Download Answer Sheets</span>
                    {loadingAllAnswerSheets && (
                      <div className="DownloadAllASBtn__loading-spinner-container">
                        <LoadingSpinner containerClassName="DownloadAllASBtn__loading-spinner" />
                      </div>
                    )}
                  </SingleAction>
                </AccessibilityWrapper>
              )}
            {showDuplicateQuiz && !isCoTaught && (
              <DuplicateQuizAction
                assessmentId={assessment_id}
                onClose={closePopUp}
              />
            )}
            {isCoTaught && <DuplicatePseudoAction />}
            {showEdit && !isCoTaught && (
              <EditAction
                title={(showIcons) =>
                  showIcons ? 'Edit Quiz' : 'Edit Assessment'
                }
                arialLabel={(showIcons) =>
                  showIcons ? 'Edit Quiz' : 'Edit Assessment'
                }
                onClick={stopPropagation(onEditClick)}
                label={<span className="item-text">Edit Quiz</span>}
              />
            )}
            {isCoTaught && <EditPseudoAction />}
            {!isSPP && enableSharedAssessments && !isVideo && isSharer && (
              <SingleAction
                onClick={() => handleManageShare()}
                iconName="manage_sharing"
                title="Manage Sharing"
                ariaLabel="Manage Sharing"
              >
                Manage Sharing
              </SingleAction>
            )}
            {openEditOptionsModal && (
              <EditOptions
                isAssigned={isAssigned}
                isInProgress={isInProgress}
                onSubmit={gotoEdit}
                masterSubjectId={subjectInfo.id}
                assessmentId={assessment_id}
                onClose={() => {
                  closePopUp();
                  setOpenEditOptionsModal(false);
                }}
              />
            )}
            {showGenerateNewAnswerSheets &&
              canRenderPaperscorerAnswerSheets &&
              showPaperscorerLinks && (
                <AccessibilityWrapper>
                  <SingleAction
                    role="button"
                    tabIndex="0"
                    onClick={() => {
                      closePopUp();
                      setModalOpen(true);
                    }}
                    className="text-left"
                    iconName="generate_sheet"
                  >
                    <span className="item-text">
                      Generate New Answer Sheets
                    </span>
                  </SingleAction>
                </AccessibilityWrapper>
              )}
            {showMarkComplete && (
              <MarkCompleteAction
                assignmentId={assignment_id}
                onUpdate={
                  (overrides && overrides.mark_complete) ||
                  (() => {
                    isSPP && sendSppMarkCompleteEvent();
                    fetchAssessmentData();
                    closePopUp();
                  })
                }
              />
            )}
            {showVideoMarkComplete && showVideoMarkCompleteFlag && (
              <VideoMarkCompleteAction
                assignmentId={assignment_id}
                onUpdate={
                  (overrides && overrides.video_mark_complete) ||
                  (() => {
                    fetchAssessmentData();
                  })
                }
              />
            )}
            {showMarkCompleteWithModal && (
              <MarkCompleteWithModalAction
                onComplete={() => {
                  onComplete();
                  isSPP && sendSppMarkCompleteEvent();
                  closePopUp();
                }}
              />
            )}
            {showReOpen && (
              <ReOpenAction
                assignmentId={assignment_id}
                onReOpen={overrides?.re_open}
                afterReopen={
                  !overrides?.re_open
                    ? () => {
                        isSPP && sendSppMarkCompleteEvent();
                        fetchAssessmentData();
                        closePopUp();
                      }
                    : null
                }
              />
            )}
            {showPreview && (
              <PreviewAction
                assessmentId={assessment_id}
                location={location}
                assessmentPreviewURL={assessmentPreviewURL}
                videoProviderId={videoId}
                previewOpened={() => {
                  closePopUp();
                  sendTelemetryEvent &&
                    sendTelemetryEvent({ eventType: 'preview_action' });
                }}
                subjectInfo={subjectInfo}
                isVideo={isVideo}
                isSPP={isSPP}
              />
            )}
            {showReassign && !isCoTaught && (
              <AssignAction
                isReassign
                forcePopupClose
                subjectInfo={subjectInfo}
                assessment={assessment}
                assignment={assignment}
                onAssign={onAssign}
                onClose={closePopUp}
                {...videoAssignProps}
              />
            )}
            {showAvailableResultsForStudentsAction && (
              <ShowHideResultsForStudentsAction
                assignment={assignment}
                fetchAssessmentData={fetchAssessmentData}
              />
            )}
            {showShareQuiz && !isPDF && !isCoTaught && (
              <SingleAction
                isNaked
                onClick={() => {
                  const newQuery = {
                    ...query,
                    shareAssessmentInviteItemId:
                      shareAssessmentInviteItemId || assessment.id,
                    assessmentTitle,
                  };
                  const newPathname = buildUrl(routes, null, params, newQuery);
                  router.push(newPathname);
                }}
                aria-label="Share Quiz"
                iconName="share_invite"
              >
                <span className="item-text">Share Quiz</span>
              </SingleAction>
            )}
            {isCoTaught && <SharePseudoAction />}
            {hasSubmitUnsubmit &&
              teacherSubmitUnsubmitFF &&
              hasOneInProgressSubmission && (
                <SubmitUnsubmit
                  assignmentId={assignment_id}
                  labelText="Submit All Unsubmitted"
                  dialogTitle="Confirm Submit All"
                  dialogText="Are you sure you want to submit all students’ in-progress assignments?"
                  userIds={userIdsWithProgress}
                  onUpdate={() => {
                    fetchAssignmentData();
                    closePopUp();
                  }}
                  numberOfUnsubmittedAssignments={
                    numberOfUnsubmittedAssignments
                  }
                  assessmentId={assessment_id}
                  classId={classId}
                />
              )}
            {showLabelActions && isAssignmentsPage && !isPDF && (
              <FlyoutSecondMenu
                isNarrow
                className="update-labels"
                trigger={(buttonProps, isOpen, reference) => (
                  <SingleAction
                    isNaked
                    aria-label="Update Labels"
                    iconName="update_label"
                    ref={reference}
                    {...buttonProps}
                  >
                    <span className="text-16 item-text">Update Labels</span>
                  </SingleAction>
                )}
              >
                <LabelListMenu
                  onClose={updateLabels}
                  assignedLabels={assessment.labels}
                  isAdminOrCoordinator={isAdminOrCoordinator}
                />
              </FlyoutSecondMenu>
            )}
            {showUpdateSettings && (
              <UpdateSettingsAction
                assessment={assessment}
                assignment={assignment}
                subjectInitId={{
                  ...subjectInfo,
                  initId: Number(subjectInitId),
                }}
                onUpdate={onUpdate || fetchAssessmentData}
                onActionClick={onUpdateClick}
                onClose={closePopUp}
                isPilot={isPilot}
                isVideo={isVideo}
                isSPP={isSPP}
                videoUnit={videoUnit}
                videoId={videoId}
                startsAt={startsAt}
                dueAt={dueAt}
                isPPC={type === 'ppc'}
              />
            )}
            {showUnlock &&
              (hasClasses || isAdminOrCoordinator) &&
              (isPPC ? (
                <AssignAction
                  subjectInfo={subjectInfo}
                  assessment={assessment}
                  assignment={assignment || {}}
                  onAssign={onAssign}
                  title="Unlock Quiz"
                  onClose={closePopUp}
                />
              ) : (
                <UnlockAction
                  assignmentId={assignment_id}
                  onUpdate={() => {
                    fetchAssessmentData();
                    closePopUp();
                  }}
                  subjectInfo={subjectInfo}
                />
              ))}
            {showUploadAnswerSheets &&
              hasActiveAnswersheets &&
              showPaperscorerLinks && (
                <AccessibilityWrapper>
                  <SingleAction
                    role="button"
                    tabIndex="0"
                    onClick={() => uploadRef.current.click()}
                    className="text-left"
                    iconName="upload_sheet"
                    title="Upload Answer Sheets"
                    ariaLabel="Upload Answer Sheets"
                  >
                    <input
                      type="file"
                      multiple
                      accept=".pdf, .jpg, .png, .jpeg"
                      hidden
                      ref={uploadRef}
                      onChange={uploadFiles}
                    />
                    <span className="item-text">Upload Answer Sheets</span>
                    {uploadLoading && (
                      <LoadingSpinner
                        containerClassName="TableActions__upload-answer-sheets-spinner"
                        data-test-loading
                      />
                    )}
                  </SingleAction>
                </AccessibilityWrapper>
              )}
            {showViewResults && (
              <div className="text-left">
                <ViewResultsAction
                  assignmentId={assignment_id}
                  basePathname={basePathname}
                  subjectInfo={subjectInfo}
                  onClick={closePopUp}
                />
              </div>
            )}
            {!isSPP && enableSharedAssessments && !isVideo && !isPDF && (
              <ViewQuizSummaryAction
                role="link"
                quizSummaryId={assessment_id}
                closePopUp={closePopUp}
              />
            )}
          </Fragment>
        </AccessibleMenuWithArrows>
      </PopOver>
      {modalOpen && (
        <GenerateAnswerSheetModal
          isQB={!isPPC}
          setModalOpen={setModalOpen}
          params={params}
          sectionStudents={sectionStudents}
          assignmentId={assignment_id}
          assignmentTitle={title}
          sectionName={section}
          closePopUp={closePopUp}
          userData={userData}
          assignment={assignment}
          skipQuestionTypeQuery={false}
        />
      )}
    </Fragment>
  );
};

function mapStateToProps(state) {
  return {
    subjectInfo: state.subject.data,
    me: state.userData.me,
    userData: state.userData,
    showAttestationFlag: state.featureFlag.show_attestation_confirmation_dialog,
    showVideoMarkCompleteFlag: state.featureFlag.show_video_mark_complete,
    showPaperscorerLinks: state.featureFlag.PS_links_in_actions_dropdown,
    paperScorerAnswerSheets: state.featureFlag.paperscorer_answer_sheets,
    showLabelActions: state.featureFlag.teacher_organize,
    resultsAssignmentActionsEnabled:
      state.featureFlag.results_assignment_actions,
    submissions: state.teacherAssignment.submissionData.submissions,
    loadingAllAnswerSheets: get(state, 'paperscorer.loadingAllAnswerSheets'),
    subjectName: get(state, 'subject.data.name', ''),
    userClasses: state.classes.items,
    chosenEducationPeriodCode: state.userData.chosenEducationPeriodCode,
    studentsBySection: state.studentsBySection || {},
    apEditQuizInPreview: state.featureFlag.ap_edit_quiz_in_preview,
    enableSharedAssessments: state.featureFlag.shared_assessments,
    useNewGroupedActionsFF: state.featureFlag.use_new_grouped_actions,
  };
}

const mapDispatchToProps = {
  downloadAllAnswerSheets: downloadAllAnswerSheetsAction,
};

export default compose(
  graphqlWrapper,
  withApollo,
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
)(Actions);
